import {
  GET_TRIAGE_FORMS,
  ADD_TRIAGE_FORM,
  UPDATE_TRIAGE_FORM,
  DELETE_TRIAGE_FORM,
  TRIAGE_FORM_LOADING,
  ADD_TRIAGE_FORM_LOADING,
  DELETE_TRIAGE_FORM_LOADING,
  SET_TRIAGE_FORM_ERRORS,
  SET_ADD_TRIAGE_FORM_ERRORS,
  CLEAR_TRIAGE_FORM_ERRORS,
} from "../types";

const initialState = {
  loading_triage_forms: false,
  loading_add_triage_form: false,
  loading_delete_triage_form: false,
  triage_forms: [],
  triage_forms_errors: null,
  add_triage_form_errors: null,
};

export default function triageFormsReducer(state = initialState, action) {
  switch (action.type) {
    case TRIAGE_FORM_LOADING:
      return {
        ...state,
        loading_triage_forms: true,
      };
    case ADD_TRIAGE_FORM_LOADING:
      return {
        ...state,
        loading_add_triage_form: true,
      };
    case DELETE_TRIAGE_FORM_LOADING:
      return {
        ...state,
        loading_delete_triage_form: true,
      };
    case GET_TRIAGE_FORMS:
      return {
        ...state,
        triage_forms: action.payload,
        loading_triage_forms: false,
      };
    case ADD_TRIAGE_FORM:
      return {
        ...state,
        triage_forms: [action.payload, ...state.triage_forms],
        loading_add_triage_form: false,
      };
    case UPDATE_TRIAGE_FORM:
      return {
        ...state,
        triage_forms: state.triage_forms.map((form) =>
          form.id === action.payload.id ? action.payload : form,
        ),
        loading_add_triage_form: false,
      };
    case DELETE_TRIAGE_FORM:
      return {
        ...state,
        triage_forms: state.triage_forms.filter(
          (form) => form.id !== action.payload,
        ),
        loading_delete_triage_form: false,
      };
    case SET_TRIAGE_FORM_ERRORS:
      return {
        ...state,
        loading_triage_forms: false,
        loading_delete_triage_form: false,
        triage_forms_errors: action.payload,
      };
    case SET_ADD_TRIAGE_FORM_ERRORS:
      return {
        ...state,
        loading_add_triage_form: false,
        add_triage_form_errors: action.payload,
      };
    case CLEAR_TRIAGE_FORM_ERRORS:
      return {
        ...state,
        triage_forms_errors: null,
        add_triage_form_errors: null,
      };
    default:
      return state;
  }
}
